import { render, staticRenderFns } from "./NewEducationPartner.vue?vue&type=template&id=eb04b836&"
import script from "./NewEducationPartner.vue?vue&type=script&lang=js&"
export * from "./NewEducationPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports